import classnames from 'classnames'

export default function Checkbox({ checked, className, error, ...inputProps }) {
  return (
    <div className='wrapper'>
      <input
        className={classnames(className, { error })}
        type='checkbox'
        value={checked}
        checked={checked}
        {...inputProps}
      />

      <style jsx>{`
        .wrapper {
          background: transparent !important;
        }

        input {
          position: relative;
          width: 2.3rem;
          height: 2.3rem;
          border: 0.3rem solid var(--separator-line-color);
          border-radius: 0.3rem;
          appearance: none;
          outline: 0;
          cursor: pointer;

          &::before {
            position: absolute;
            display: block;
            content: '';
            top: 0.1rem;
            left: 0.5rem;
            width: 0.5rem;
            height: 1rem;
            border-style: solid;
            border-color: var(--primary-color);
            border-width: 0 0.2rem 0.2rem 0;
            transform: rotate(45deg);
            opacity: 0;
          }

          &:checked {
            &::before {
              opacity: 1;
            }

            ~ label::before {
              clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            }
          }

          &.error {
            border: 0.3rem solid var(--alert-color);
          }
        }

        @media (max-width: 1024px) {
          input {
            width: 2rem;
            height: 2rem;

            &::before {
              top: 0.18rem;
              left: 0.4rem;
              width: 0.45rem;
              height: 0.7rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
